
/**
 * 		Search UI logic to export HTML to PDF.
 *
 * 		@author Irina Patrikeeva <irina.i.patrikeeva@nasa.gov>
 *
 *     	Created on 07/24/2018
 *     	Modified on 03/04/2019
 */

/**
 * Export to PDF button click listener
 * @param title {string} - record title value (may be 'undefined')
 * @param type {string} - type of record
 */
function exportToPdf( title, type ) {

    var domain,
        headerTitle = "Record Viewer";

    // var alias = App.globalState.alias;

    if ( sharedStylesGlobals && sharedStylesGlobals.domain ) {
        var domainConfig = sharedStylesGlobals.domain;
        domain = domainConfig.SiteName;
    }

    if ( ! title || title === 'undefined') {
       title = headerTitle;
    }

    if ( domain ) {
        title = domain + " " + title;
    }

    if ( typeof printJS !== "undefined" ) {

        // Expand accordions in part and component viewer to print
        if ( type === "EMU Component" || type === "Component" || type === "EMU Part" || type === "Part" ) {
            title = type + " " + "Viewer";
        }

        // Print the page as a PDF file: brings up a dialog with an option to view, print and save the PDF
        printJS({
            printable: 'content',
            type: 'html',
            documentTitle: window.location.href,
            header: title,
            css: [ '/edi/stylesheets/app.css', '/edi/stylesheets/vendor.css' ],
            scanStyles: true,
            // maxWidth: 800,
            style: '',
            targetStyle: '*',
            ignoreElements: [ 'search-loading-icon','record-buttons', 'graph-region' ],
            showModal: true
        });
    }
}